import "../App.css";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import PasswordField from "../PasswordField";
import { Alert, Spinner } from "react-bootstrap";
import * as Yup from "yup";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import countryToCurrency from "country-to-currency";
import axios from "axios";
import {
  API_BASE_URL,
  DISABLE_CAPTCHA,
  LOCAL_CAPTCHA_TOKEN,
} from "../../config/config";
import dayjs from "dayjs";
import CaptchaField from "../CaptchaField";
import { Link, useNavigate } from "react-router-dom";

const FurnitureRegistration = () => {
  const [currencies, setCurrencies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [recaptchaToken, setRecaptchatToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {}, [selectedImages]);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  const handleImageChange = (event) => {
    const files = event.target.files;
    setSelectedImages([...files]);
  };

  const handleInvoiceChange = (event) => {
    const file = event.target.files[0];
    setSelectedInvoice(file);
  };

  const calculateCareValues = (values) => {
    if (values.productCondition === "New Purchase") {
      values.careFees = (values.billValue * 0.1).toFixed(2);
    } else {
      values.careFees = (values.billValue * 0.05).toFixed(2);
    }

    if (values.productCondition === "New Purchase") {
      values.careValueAmount = Number(values.billValue).toFixed(2);
    } else {
      if (values.oldPurchaseOption === "1-2 years old") {
        values.careValueAmount = (values.billValue * 0.75).toFixed(2);
      } else if (values.oldPurchaseOption === "2-3 years old") {
        values.careValueAmount = (values.billValue * 0.5).toFixed(2);
      } else {
        values.careValueAmount = (values.billValue * 0.25).toFixed(2);
      }
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const formData = new FormData();

      values.services.forEach((service, index) => {
        calculateCareValues(service);

        formData.append("invoice", selectedInvoice);

        selectedImages.forEach((image) => {
          formData.append("pictures", image);
        });

        Object.entries(service).forEach(([key, value]) => {
          if (key !== "invoice" && key !== "pictures") {
            formData.append(`services[${index}][${key}]`, value);
          }
        });
      });

      Object.keys(values).forEach((key) => {
        if (key !== "services") {
          formData.append(key, values[key]);
        }
      });

      formData.append(
        "recaptchaToken",
        DISABLE_CAPTCHA ? LOCAL_CAPTCHA_TOKEN : recaptchaToken,
      );

      console.log(values);

      await axios.post(`${API_BASE_URL}/register`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccess(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      console.error("Error:", error.response?.data?.error || error.message);
      setError("Error submitting the form");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleCaptchaChange = (token) => {
    if (token) {
      setRecaptchatToken(token);
    }
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <Formik
            initialValues={{
              services: [
                {
                  type: "Auto",
                  category: "",
                  productCondition: "",
                  oldPurchaseOption: "",
                  brandName: "",
                  serialNo: "",
                  currency: "",
                  careValueAmount: 0,
                  billValue: "",
                  productPurchaseDate: "",
                  careExpireTimeline: "1 Year",
                  careFees: 0,
                  carePurchaseDate: "",
                  careExpiryDate: "",
                  invoice: "",
                  pictures: [],
                  referralCode: "",
                },
              ],
              password: "",
              email: "",
              fName: "",
              mName: "",
              lName: "",
              country: "",
              city: "",
              state: "",
              zip: "",
              contact: "",
            }}
            validationSchema={Yup.object({
              password: Yup.string()
                .required("Password is required")
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 digit, 1 special character, and be at least 8 characters long",
                ),
              email: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
              fName: Yup.string().required("First Name is required"),
              lName: Yup.string().required("Last Name is required"),
              country: Yup.string().required("Country is required"),
              city: Yup.string(),
              state: Yup.string(),
              zip: Yup.string()
                .required("Zip is required")
                .matches(/^\d+$/, "Zip must only contain digits")
                .min(5, "Zip must be at least 5 digits")
                .max(10, "Zip cannot exceed 10 digits"),
              contact: Yup.string()
                .required("Contact is required")
                .matches(/^\d+$/, "Contact must only contain digits")
                .min(7, "Contact must be at least 7 digits")
                .max(15, "Contact cannot exceed 15 digits"),
            })}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form noValidate>
                {formik.submitCount > 0 &&
                  Object.keys(formik.errors).length > 0 && (
                    <Alert variant="warning" style={{ marginBottom: "1rem" }}>
                      Please correct the highlighted errors before submitting.
                    </Alert>
                  )}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="email" id="emailLabel">
                      Email
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="email"
                      id="email"
                    />
                    <ErrorMessage name="email" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor="password" id="passwordLabel">
                      Set Your Password
                    </InputLabel>
                    <Field
                      name="password"
                      id="password"
                      component={PasswordField}
                      style={{ width: "100%" }}
                      size="small"
                    />
                    <ErrorMessage name="password" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="fName" id="fNameLabel">
                      First Name
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="fName"
                      id="fName"
                    />
                    <ErrorMessage name="fName" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="mName" id="mNameLabel">
                      Middle Name
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="mName"
                      id="mName"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="lName" id="lNameLabel">
                      Last Name
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="lName"
                      id="lName"
                    />
                    <ErrorMessage name="lName" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <InputLabel htmlFor="country" id="countryLabel">
                      Select Country
                    </InputLabel>
                    <CountryDropdown
                      value={formik.values.country}
                      onChange={(val) => formik.setFieldValue("country", val)}
                      className="form-control"
                      name="country"
                      id="country"
                    />
                    <ErrorMessage name="country" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="state" id="stateLabel">
                      State
                    </InputLabel>
                    <Field
                      as={RegionDropdown}
                      country={formik.values.country}
                      value={formik.values.state}
                      onChange={(val) => formik.setFieldValue("state", val)}
                      className="form-control"
                      name="state"
                      id="state"
                    />
                    <ErrorMessage name="state" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="city" id="cityLabel">
                      City
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="city"
                      id="city"
                    />
                    <ErrorMessage name="city" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputLabel htmlFor="zip" id="zipLabel">
                      Zip Code
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="zip"
                      id="zip"
                    />
                    <ErrorMessage name="zip" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <InputLabel htmlFor="contact" id="contactLabel">
                      Contact
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name="contact"
                      id="contact"
                    />
                    <ErrorMessage name="contact" />
                  </Grid>
                </Grid>
                {formik.values.services.map((service, index) => (
                  <div key={index}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].category`}>
                          Select Product Category
                        </InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].category`}
                          id={`services[${index}].category`}
                        >
                          <MenuItem value="Sofa Sets">Sofa Sets</MenuItem>
                          <MenuItem value="Chairs">Chairs</MenuItem>
                          <MenuItem value="Coffee and End Tables">
                            Coffee and End Tables
                          </MenuItem>
                          <MenuItem value="Seats">Seats</MenuItem>
                          <MenuItem value="Recliners">Recliners</MenuItem>
                          <MenuItem value="Mattresses">Mattresses</MenuItem>
                          <MenuItem value="Beds">Beds</MenuItem>
                          <MenuItem value="Dressers">Dressers</MenuItem>
                          <MenuItem value="Chest">Chest</MenuItem>
                          <MenuItem value="Bunk Beds">Bunk Beds</MenuItem>
                          <MenuItem value="Vanity Sets">Vanity Sets</MenuItem>
                          <MenuItem value="Bar Stools">Bar Stools</MenuItem>
                          <MenuItem value="Dining Tables">
                            Dining Tables
                          </MenuItem>
                          <MenuItem value="Dining Sets">Dining Sets</MenuItem>
                          <MenuItem value="File Cabinets">
                            File Cabinets
                          </MenuItem>
                        </Field>
                        <ErrorMessage name={`services[${index}].category`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].brandName`}>
                          Brand Name
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].brandName`}
                          id={`services[${index}].brandName`}
                        />
                        <ErrorMessage name={`services[${index}].brandName`} />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel>Product Condition</InputLabel>
                        <FormControl component="fieldset">
                          <Field name={`services[${index}].productCondition`}>
                            {({ field }) => (
                              <>
                                <FormControlLabel
                                  control={<Radio />}
                                  label="New Purchase"
                                  value="New Purchase"
                                  checked={field.value === "New Purchase"}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      `services[${index}].productCondition`,
                                      "New Purchase",
                                    );
                                    formik.setFieldValue(
                                      `services[${index}].oldPurchaseOption`,
                                      "",
                                    );
                                  }}
                                />
                                <FormControlLabel
                                  control={<Radio />}
                                  label="Old Purchase"
                                  value="Old Purchase"
                                  checked={field.value === "Old Purchase"}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      `services[${index}].productCondition`,
                                      "Old Purchase",
                                    );
                                  }}
                                />
                                {field.value === "Old Purchase" && (
                                  <>
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="1-2 years old"
                                      value="1-2 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption === "1-2 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "1-2 years old",
                                        );
                                      }}
                                    />
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="2-3 years old"
                                      value="2-3 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption === "2-3 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "2-3 years old",
                                        );
                                      }}
                                    />
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="More than 3 years old"
                                      value="More than 3 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption ===
                                        "More than 3 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "More than 3 years old",
                                        );
                                      }}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </Field>
                          <ErrorMessage
                            name={`services[${index}].productCondition`}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].serialNo`}>
                          Product Serial Number
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].serialNo`}
                          id={`services[${index}].serialNo`}
                        />
                        <ErrorMessage name={`services[${index}].serialNo`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel>Purchase Date</InputLabel>
                        <div className="date-input">
                          <DatePicker
                            format="MM/DD/YYYY"
                            slotProps={{
                              textField: { size: "small", fullWidth: true },
                            }}
                            value={
                              formik.values.services[index].productPurchaseDate
                                ? dayjs(
                                    formik.values.services[index]
                                      .productPurchaseDate,
                                  )
                                : null
                            }
                            onChange={(date) => {
                              formik.setFieldValue(
                                `services[${index}].productPurchaseDate`,
                                date && date.isValid()
                                  ? date.format("YYYY-MM-DD")
                                  : null,
                              );
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name={`services[${index}].productPurchaseDate`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].invoice`}>
                          Invoice
                        </InputLabel>
                        <input
                          style={{ width: "100%" }}
                          size="small"
                          type="file"
                          name={`services[${index}].invoice`}
                          id={`services[${index}].invoice`}
                          onChange={handleInvoiceChange}
                        />
                        <ErrorMessage name={`services[${index}].invoice`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].pictures`}>
                          Pictures
                        </InputLabel>
                        <input
                          style={{ width: "100%" }}
                          size="small"
                          type="file"
                          name={`services[${index}].pictures`}
                          id={`services[${index}].pictures`}
                          onChange={handleImageChange}
                          multiple
                        />
                        <ErrorMessage name={`services[${index}].pictures`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel>Select Currency</InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].currency`}
                          id={`services[${index}].currency`}
                        >
                          <MenuItem value="">Select Currency</MenuItem>
                          {currencies.map((currency) => (
                            <MenuItem key={currency} value={currency}>
                              {currency}
                            </MenuItem>
                          ))}
                        </Field>
                        <ErrorMessage name={`services[${index}].currency`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].billValue`}>
                          Product Bill Value
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].billValue`}
                          id={`services[${index}].billValue`}
                        />
                        <ErrorMessage name={`services[${index}].billValue`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].referralCode`}>
                          Referral Code (If Any)
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].referralCode`}
                          id={`services[${index}].referralCode`}
                        />
                        <ErrorMessage
                          name={`services[${index}].referralCode`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careFees`}
                          id={`careFeesLabel_${index}`}
                          align="center"
                        >
                          Care Fees to Pay
                        </InputLabel>
                        <Typography
                          variant="h6"
                          align="center"
                          name={`services[${index}].careFees`}
                        >
                          {service.productCondition === "New Purchase"
                            ? `${(service.billValue * 0.1).toFixed(2)}`
                            : `${(service.billValue * 0.05).toFixed(2)}`}
                          {service.currency && " " + service.currency}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careValueAmount`}
                          id={`careValueAmountLabel_${index}`}
                          align="center"
                        >
                          Your Care Value for 1st Year will be
                        </InputLabel>
                        <Typography
                          variant="body1"
                          align="center"
                          name={`services[${index}].careValueAmount`}
                        >
                          {service.productCondition === "New Purchase"
                            ? `${Number(service.billValue).toFixed(2)}`
                            : `${
                                service.oldPurchaseOption === "1-2 years old"
                                  ? (service.billValue * 0.75).toFixed(2)
                                  : service.oldPurchaseOption ===
                                      "2-3 years old"
                                    ? (service.billValue * 0.5).toFixed(2)
                                    : (service.billValue * 0.25).toFixed(2)
                              }`}
                          {service.currency && " " + service.currency}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                ))}
                <CaptchaField
                  onChange={handleCaptchaChange}
                  wrapperStyle={{ display: "flex" }}
                  style={{
                    margin: "0 auto",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                />
                <div className="submission-popup">
                  <div className="loading">
                    {loading && <Spinner animation="border" />}
                  </div>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && (
                    <Alert variant="success">
                      Form submitted successfully!
                    </Alert>
                  )}
                </div>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      disabled={formik.isSubmitting || loading}
                      style={{ marginTop: "1rem" }}
                    >
                      {formik.isSubmitting || loading
                        ? "Submitting..."
                        : "Register"}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </DemoContainer>
      </LocalizationProvider>
      <div style={{ marginTop: "1rem", textAlign: "center" }}>
        <Typography variant="body1">
          Already a user? <Link to="/login">Login</Link>
        </Typography>
      </div>
    </div>
  );
};

export default FurnitureRegistration;
